import { DEFAULTS } from '@photo-sphere-viewer/core';
import * as events from './events';

DEFAULTS.lang.resolution = 'Quality';

export { ResolutionPlugin } from './ResolutionPlugin';
export * from './model';
export { events };
